const { onSnapshot } = require('firebase/firestore');

function loggingEnabled() {
  if (typeof window === 'undefined') return false;
  if (window.SPACHE_FIRESTORE_TIMING === true) return true;
  return ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
}

function slowCallThreshold() {
  const configured = Number(window.SPACHE_FIRESTORE_SLOW_CALL_MS ?? 250);
  return Number.isFinite(configured) && configured >= 0 ? configured : 250;
}

function logFirestoreTiming(operation, target, startedAt, result, error) {
  if (!loggingEnabled()) return;

  const elapsedMs = Number((performance.now() - startedAt).toFixed(1));
  if (!error && elapsedMs < slowCallThreshold()) return;

  const details = { service: 'browser-client', operation, target, elapsedMs };
  if (typeof result?.metadata?.fromCache === 'boolean') {
    details.fromCache = result.metadata.fromCache;
  }
  if (Array.isArray(result?.docs)) details.resultCount = result.docs.length;
  if (error) details.errorCode = error.code || error.name || 'unknown';

  console.warn('Firestore operation slow or failed:', details);
}

async function timedFirestoreCall(operation, target, call) {
  const startedAt = performance.now();
  try {
    const result = await call();
    logFirestoreTiming(operation, target, startedAt, result);
    return result;
  } catch (error) {
    logFirestoreTiming(operation, target, startedAt, null, error);
    throw error;
  }
}

function timedFirestoreSubscription(target, reference, onUpdate, onError) {
  const startedAt = performance.now();
  let loggedInitialServerSnapshot = false;

  return onSnapshot(
    reference,
    { includeMetadataChanges: true },
    snapshot => {
      if (!loggedInitialServerSnapshot && snapshot.metadata.fromCache === false) {
        loggedInitialServerSnapshot = true;
        logFirestoreTiming('listener.initial-server-snapshot', target, startedAt, snapshot);
      }
      onUpdate(snapshot);
    },
    error => {
      logFirestoreTiming('listener.error', target, startedAt, null, error);
      if (onError) onError(error);
    }
  );
}

module.exports = { timedFirestoreCall, timedFirestoreSubscription };

